export { addWithConfigToMap, addWithConfig, withConfig } from './with-config';
